module.exports = __webpack_public_path__ + "static/media/serum-facial.83e0100c.png";